import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { UnespCoreMessageService } from '@unesp/core'
import { finalize, map, Observable, throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { CacheService } from 'src/app/shared/services/cache.service'

@Injectable({
  providedIn: 'root',
})
export class RequestInterceptorService implements HttpInterceptor {
  private requestsInProgress = new Set<string>() // Armazena requisições em andamento

  constructor(
    private unespCoreMessageService: UnespCoreMessageService,
    private cacheService: CacheService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Exceções para certas URLs
    if (
      request.url.startsWith('https://viacep.com.br/ws') ||
      request.url.startsWith('https://unesp.br/portaldocentes/api')
    ) {
      return next.handle(request.clone({ headers: new HttpHeaders(), withCredentials: false }))
    }

    // Prevenir requisições POST duplicadas
    if (request.method === 'POST') {
      const requestKey = request.urlWithParams

      if (this.requestsInProgress.has(requestKey)) {
        return new Observable<HttpEvent<any>>() // Cancela a requisição duplicada
      }

      this.requestsInProgress.add(requestKey)
    }

    return next.handle(request).pipe(
      map(res => {
        if (res instanceof HttpResponse) {
          if (request.url.includes('/auth/logout')) {
            this.cacheService.clearAll()
          }
          // Tratamento especial para status 205 em URLs de autenticação
          if (res.status === 205 && request.url.includes('auth')) {
            this.unespCoreMessageService.showMessageInfo(
              'Ajustamos alguns dados de acesso. Tente logar novamente.',
              undefined,
              5000
            )
          }
        }
        return res
      }),
      catchError(err => throwError(() => err)),
      finalize(() => {
        // Remove a requisição da lista quando a resposta chega
        if (request.method === 'POST') {
          this.requestsInProgress.delete(request.urlWithParams)
        }
      })
    )
  }
}
